//import { useEffect, useState } from "react";
//import { useAuth, useStorage } from "blustai-preact-core";
//import GoogleBtn from '../../assets/continue_with_google.png';
//import LoadingIcon from "../../icons/LoadingIcon";

interface OAuthButtonProps {
  provider: string;
  text?: string;
  onError?: (error: string) => void;
  consent?: boolean;
  className?: string;
  disabled?: boolean;
}

const OAuthButton = ({ /*provider, text, onError, consent, className, disabled*/ }: OAuthButtonProps) => {
  //const [loading, setLoading] = useState(false);


  //const { oauth, logout } = useAuth();
  //const { setStorageItem } = useStorage();

  /*const signInWith = async (provider: string) => {
    if (!consent) {
      onError("Consent is required.");
      return;
    }
    setLoading(true);
    try {
      await logout();
      setStorageItem("auth_redirect", window.location.href);
      await oauth(provider);
    } catch (err: any) {
      onError(err.error || err.message || "Authentication error");
    } finally {
      setLoading(false);
    }
  };

  const capitalize = (string: string) => string.charAt(0).toUpperCase() + string.slice(1);
*/
  return null;

  /*return <>
    {provider === 'google' ?
      <button type="button" className={`${className} w-full flex flex-row justify-center items-center pt-0 pb-0 `} style={{ backgroundColor: '#f2f2f2' }} onClick={() => signInWith(provider)} disabled={disabled}>
        <img src={GoogleBtn} className={"h-full"} />
        {loading &&
          <div className={"ml-2"}>
            <LoadingIcon size="20" />
          </div>
        }
      </button>
      : <button type="button" className={`${className} w-full flex flex-row justify-center`}  onClick={() => signInWith(provider)} disabled={disabled}>
        {text || ('Sign In with ' + capitalize(provider))}
        {loading &&
          <div className={"ml-2"}>
            <LoadingIcon size="20" />
          </div>
        }
      </button>
    }
  </>*/
};

export default OAuthButton;
